export const mockServices = [
  {
    id: 1,
    title: "Open Car Hauling",
    description: "Safe and reliable open transport for your vehicles. Perfect for standard car shipping across the country.",
    icon: "truck",
    features: [
      "Coast-to-coast service",
      "Real-time tracking",
      "Fully insured",
      "Competitive pricing"
    ]
  },
  {
    id: 2,
    title: "Enclosed Transport",
    description: "Premium protection for luxury, classic, and motorcycle transport with enclosed trailers.",
    icon: "shield",
    features: [
      "Weather protection",
      "Enhanced security",
      "Luxury vehicle specialists",
      "Door-to-door service"
    ]
  },
  {
    id: 3,
    title: "Motorcycle Shipping",
    description: "Specialized motorcycle transport with custom equipment and experienced handlers.",
    icon: "bike",
    features: [
      "Custom tie-down systems",
      "Enclosed options available",
      "Multiple bike capacity",
      "Expert handling"
    ]
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Michael Rodriguez",
    role: "Business Owner",
    content: "Rocketdash transported my classic Mustang from California to Texas. The service was exceptional, and my car arrived in perfect condition. Highly recommend!",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Thompson",
    role: "Customer",
    content: "Fast, professional, and affordable. They handled my motorcycle shipment with care and kept me updated throughout the entire process.",
    rating: 5
  },
  {
    id: 3,
    name: "David Chen",
    role: "Car Collector",
    content: "I've used several auto transport companies, but Rocketdash stands out. Their attention to detail and customer service is unmatched.",
    rating: 5
  }
];

export const mockStats = [
  { label: "Vehicles Transported", value: "3,500+" },
  { label: "Years in Business", value: "5+" },
  { label: "Customer Satisfaction", value: "99%" },
  { label: "States Serviced", value: "48" }
];

export const mockQuotes = [];

export const mockContacts = [];